import { gql } from '@apollo/client';

export const FETCH_REPORT_DEFINITIONS = gql`
    query fetchReportDefinitions($filter: ReportDefinitionFilter!) {
        facility {
            id
            reportDefinitions(filter: $filter) {
                id
                alias
                name
                activeFromTime
                activeToTime
                type {
                    name
                }
                schedules {
                    id
                    executionLogs(filter: { latest_execution: true }) {
                        outcome
                    }
                }
            }
        }
    }
`;
